<template>
  <CollapsibleCard
    :value="true"
    collapsibleIcon="mdi-map"
    collapsibleTitle="Lokasjon"
    :padding="true"
  >
    <template v-slot>
      <div v-if="loading" class="text-center pb-4">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else>
        <CardContent v-model="data" />
      </div>
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  name: "ComplaintLocationCard",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    data() {
      var data = [
        {
          icon: "mdi-home-city-outline",
          title: "Prosjekt",
          content: this.value?.projectName,
        },
        {
          icon: "mdi-home-outline",
          title: "Bygg",
          content: this.value?.houseNum,
        },
        {
          icon: "mdi-map-marker-outline",
          title: "Adresse",
          content: this.value?.address,
          href: this.value?.address
            ? `http://maps.google.com/maps?q=${this.value?.address}`
            : "",
          target: "_blank",
        },
        {
          icon: "mdi-account-key-outline",
          title: "Leilighet",
          content: this.value?.apartmentKey,
        },
        {
          icon: "mdi-key-outline",
          title: "Seksjon",
          content: this.value?.sectionNum,
        },
      ];

      return data;
    },
  },
  components: {
    CollapsibleCard,
    CardContent,
  },
});
</script>
